import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { DeleteFolderInput, DeleteFolderMutation } from '@/gql/graphql';

const DELETE_FOLDER_MUTATION = graphql(`
  mutation DeleteFolder($input: DeleteFolderInput!) {
    deleteFolder(input: $input)
  }
`);

const useDeleteFolder = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    DeleteFolderMutation,
    unknown,
    DeleteFolderInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(DELETE_FOLDER_MUTATION, { input });
    },
    onSuccess: () => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.folders(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useDeleteFolder;
